import * as yup from "yup";

import type { BasicRoute, RouteResponseBody, RouteSchema } from "../../..";
import type { UniteHebergementDto } from "../../../dto";

export type DeactivateUniteHebergementResponse = UniteHebergementDto;

export interface DeactivateUniteHebergementRoute extends BasicRoute {
  method: "PUT";
  path: "/hebergement/site/{siteId}/unites/{uniteId}/deactivate";
  params: { siteId: string; uniteId: string };
  query: { organismeId: number };
  response: RouteResponseBody<DeactivateUniteHebergementResponse>;
}

export const DeactivateUniteHebergementRouteSchema: RouteSchema<DeactivateUniteHebergementRoute> =
  {
    params: yup.object({
      siteId: yup.string().required("Champ obligatoire"),
      uniteId: yup
        .string()
        .matches(/^\d+$/, "L'unité d'hébergement doit être un entier")
        .required("Champ obligatoire"),
    }),
    query: yup.object({
      organismeId: yup
        .number()
        .typeError("L'organisme doit être un nombre")
        .required("Champ obligatoire"),
    }),
  };
